import { Component } from '@angular/core';
import { RootMixin, WithMenubarMixin } from '@fapp/mixins';

@Component({
  selector: 'app-no-role-layout',
  templateUrl: './no-role-layout.component.html',
  styleUrls: ['./no-role-layout.component.scss'],
  standalone: false,
})
export class NoRoleLayoutComponent extends WithMenubarMixin(RootMixin) {
  constructor() {
    super();
  }
}
